import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/empty_img.svg'


const _withScopeId = n => (_pushScopeId("data-v-229fa665"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title_more" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "empty",
  src: _imports_0
}

import { withDefaults } from 'vue';

interface Props {
  component: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MyImages',
  props: {
    component: { default: Object }
  },
  setup(__props: any) {

const props = __props as { component: any };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "box",
    style: _normalizeStyle({
      background:
        props.component.content.bg_type == 1 ? props.component.content.bg_color : props.component.content.default_bg_color,
      backgroundImage:
        props.component.content.bg_type == 1
          ? `url(${props.component.content.bg_img})`
          : props.component.content.default_bg_color,
    })
  }, [
    _createElementVNode("div", {
      class: "title flex between",
      style: _normalizeStyle({
        color:
          props.component.content.title_type == 0
            ? props.component.content.title_default_color
            : props.component.content.title_color,
      })
    }, [
      _createTextVNode(_toDisplayString(props.component.content.title), 1),
      _withDirectives(_createElementVNode("span", _hoisted_1, "更多>>", 512), [
        [_vShow, props.component.imgList.length > props.component.content.most]
      ])
    ], 4),
    _createElementVNode("div", {
      class: _normalizeClass({
        flex: props.component.content.style != 4,
        // between: props.component.content.style != 4,
        wrap: props.component.content.style != 4,
        list_box: props.component.content.style == 4,
      })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.component.imgList, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["img_box", `style_${props.component.content.style}`]),
          key: index
        }, [
          (item.url != '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: item.url,
                alt: ""
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3))
        ], 2)), [
          [_vShow, index + 1 <= props.component.content.most]
        ])
      }), 128))
    ], 2)
  ], 4))
}
}

})